import React from 'react';
import { CDBBtn, CDBLink } from "cdbreact";
import { Layout } from "../Layout";
import { TemplateNav } from "../TemplateNav";
import Sidebar from "../Sidebar";

export const Footer = () => {

	return(
		<div className="d-flex w-100">
		  <div style={{height:"100vh", overflow:"hidden initial"}}>
			<Sidebar/>
		  </div>
		  <Layout>
			<TemplateNav/>
		<div className="r-w">
      <div className="blockcode">
        <div className="header">Footer</div>
        <div className="description">FREE Footer</div>
				<footer className="shadow">
					<div className="d-flex justify-content-between align-items-center mx-auto py-4 flex-wrap" style={{width:"80%"}}>
						<div className="d-flex align-items-center">
							<CDBLink to="/" className="d-flex align-items-center p-0 text-dark">
								<img alt="logo" src="/img/logo.png" width="30px"/>
								<span className="ml-4 h5 mb-0 font-weight-bold">Devwares</span>
							</CDBLink>
							<span style={{fontSize:"3em", margin:"-2rem 0px -1.5rem 1rem", color:"#C4C4C4"}}>&#8226;</span>
	            <small className="ml-2">&copy; Devwares, 2020. All rights reserved.</small>
			      </div>
			      <div>
		          <CDBBtn size="sm" flat color="dark" >
		            <i class="fab fa-facebook-f"></i>
		          </CDBBtn>
		          <CDBBtn size="sm" flat color="dark" className="mx-3">
		            <i class="fab fa-twitter"></i>
		          </CDBBtn>
		          <CDBBtn size="sm" flat color="dark">
		            <i class="fab fa-instagram"></i>
		          </CDBBtn>
		        </div>
					</div>
				</footer>
			</div>
		</div>
      </Layout>
    </div>
	);
}
